import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";

const AffiliateLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });

  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [showPassword2, setShowPassword2] = useState(true);

  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const handleShow2 = () => {
    setShowPassword2(!showPassword2);
  };

  // Re-validate confirmPassword when password changes
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("password")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("password")]);

  // Pre-fill referral code from URL query params
  useEffect(() => {
    if (!isEmpty(search)) {
      if (search?.split("=")[0] === "?referral_code") {
        setValue("referral_code", search?.split("=")[1]);
      }
    }
  }, [search]);

  const onSubmit = async (body) => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { status, data } = await apiPost(apiPath.affiliate, {
      whatsappNumber: body?.mobile,
      username: body?.username,
      password: body?.password,
      confirmPassword: body?.confirmPassword,
      referral_code: body?.referral_code || "",
      website: hostname || "SABAEXCH",
    });
    if (status === 200) {
      if (data.success) {
        toast.success(data?.message);
        navigate("/");
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  return (
    <div className="popup-page popup-page--active popup-page--align-top">
      <div className="popup-page__backdrop" />{" "}
      <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        <div className="popup-page__main popup-page-main popup-page-main--show">
          <div className="popup-page-main__header">
            <div className="popup-page-main__title">{t("AffiliateTitle")}</div>
            <div
              onClick={() => navigate("/")}
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div className="popup-page-main__container">
            <div className="content login-biometric-content">
              <Form
                onSubmit={handleSubmit(onSubmit)}
                className="ng-untouched ng-pristine ng-invalid ng-star-inserted"
              >
                <div style={{background:'transparent'}} className="menu-box">
                  {/* Username */}
                  <div className="input-group">
                    <label>
                      <span>{t("Username")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type="text"
                      autoComplete="new-password"
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("CharactersPlaceholder")}
                      {...register("username", {
                        required: t("Enter_Username"),
                        minLength: {
                          value: 3,
                          message: t("Min3User"),
                        },
                        maxLength: {
                          value: 30,
                          message: t("Max30User"),
                        },
                        pattern: {
                          value: /^[a-zA-Z0-9]*$/,
                          message: t("Enter_Valid_Username"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.username?.message) && (
                      <div className="alert">{errors?.username?.message}</div>
                    )}
                  </div>

                  {/* Password */}
                  <div className="input-group password">
                    <div
                      onClick={() => handleShow()}
                      _ngcontent-serverapp-c2292208966=""
                      className={`eyes ${!showPassword ? "active" : ""} `}
                    />
                    <label>
                      <span>{t("Password")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type={!showPassword ? "text" : "password"}
                      autoComplete="new-password"
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("PasswordPlaceholder")}
                      {...register("password", {
                        required: t("Enter_Password"),
                        minLength: {
                          value: 6,
                          message: t("PasswordMin"),
                        },
                        maxLength: {
                          value: 20,
                          message: t("PasswordMax"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.password?.message) && (
                      <div className="alert">{errors?.password?.message}</div>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div className="input-group password">
                    <div
                      onClick={() => handleShow2()}
                      _ngcontent-serverapp-c2292208966=""
                      className={`eyes ${!showPassword2 ? "active" : ""} `}
                    />
                    <label>
                      <span>{t("Confirm_Password")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type={!showPassword2 ? "text" : "password"}
                      autoComplete="new-password"
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("Confirm_Password")}
                      {...register("confirmPassword", {
                        required: t("Enter_CPassword"),
                        validate: (value) => {
                          if (!isEmpty(watch("password"))) {
                            if (value === watch("password")) {
                              return true;
                            } else {
                              return t("PasswordMatch");
                            }
                          }
                        },
                      })}
                    />
                    {!isEmpty(errors?.confirmPassword?.message) && (
                      <div className="alert">
                        {errors?.confirmPassword?.message}
                      </div>
                    )}
                  </div>
                </div>

                {/* Password Tips */}
                <div className={`accordion-wrap tips ${show ? "show" : ""}`}>
                  <div
                    onClick={() => setShow(!show)}
                    className="a-title toggle-btn"
                  >
                    <div
                      className="a-icon"
                      style={{
                        maskImage: 'url("/assets/Other/accordion-tips.svg")',
                      }}
                    />
                    <div className="a-text">{t("Passwordrequirements")}</div>
                    <div
                      className="a-arrow"
                      style={{
                        maskImage: 'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <div className="a-content">
                    <ol className="a-list">
                      <li className="a-item ng-star-inserted">
                        {t("Mustlong")}
                      </li>
                      <li className="a-item ng-star-inserted">
                        {t("Password3")}
                      </li>
                      <li className="a-item ng-star-inserted">
                        {t("PasswordLine5")}
                      </li>
                    </ol>
                  </div>
                </div>

                <div style={{background:'transparent'}} className="menu-box">
                  {/* WhatsApp / Phone Number */}
                  <div className="input-group ng-star-inserted">
                    <label>
                      <span>{t("PhoneNumber")}</span>
                      <span className="required-mark ng-star-inserted">*</span>
                    </label>
                    <input
                      type="number"
                      autoComplete="new-password"
                      className="input ng-untouched ng-pristine ng-invalid"
                      placeholder={t("FillUpHere")}
                      {...register("mobile", {
                        required: t("Entervalidnumber"),
                        minLength: {
                          value: 10,
                          message: t("MobileMin"),
                        },
                        maxLength: {
                          value: 12,
                          message: t("MobileMax"),
                        },
                      })}
                    />
                    {!isEmpty(errors?.mobile?.message) && (
                      <div className="alert">{errors?.mobile?.message}</div>
                    )}
                  </div>

                  {/* Referral Code */}
                  <div className="input-group ng-star-inserted">
                    <label>
                      <span>{t("ReferralCode")}</span>
                    </label>
                    <input
                      type="text"
                      autoComplete="new-password"
                      className="input ng-untouched ng-pristine ng-valid"
                      placeholder={t("Optional")}
                      {...register("referral_code")}
                    />
                  </div>

                  <div className="third-party-login"></div>
                </div>

                <p className="ng-star-inserted">
                  <input
                    type="checkbox"
                    className="register-checkbox ng-untouched ng-pristine ng-valid ng-star-inserted"
                  />
                  <span> {t("Iagreeunderstandthe")} </span>
                  <a href="#">
                    {" "}
                    {t("TC")}
                  </a>
                  <span> </span>
                </p>

                <div className="button btn-primary ng-star-inserted">
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                    type="submit"
                  >
                    {t("Submit")}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AffiliateLink;
